import React from 'react'
import { Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { SPACE } from 'Theme'
import { formatQuantityWithUnit } from 'utils/formatters'
import { Counter } from './Counter'

export interface QuantityCounterProps
  extends Pick<
    React.ComponentProps<typeof Counter>,
    | 'onChange'
    | 'onIncrement'
    | 'onDecrement'
    | 'isDecrementDisabled'
    | 'isIncrementDisabled'
    | 'isDisabled'
    | 'id'
    | 'value'
  > {
  quantityUnit?: {
    singular: string
    plural: string
  }
  minimumOrderQuantity: number
  textProps?: React.ComponentProps<typeof Text>
}

export const QuantityCounter: React.FC<QuantityCounterProps> = ({
  quantityUnit,
  minimumOrderQuantity,
  id,
  value,
  onChange,
  onIncrement,
  onDecrement,
  isIncrementDisabled,
  isDecrementDisabled,
  isDisabled,
  textProps,
  ...rest
}) => (
  <Flex flexDirection="column">
    <Text mb={SPACE.PX_5} {...textProps}>
      Qty{quantityUnit && ` (${quantityUnit.plural})`}
    </Text>
    <Counter
      id={id}
      value={value}
      onChange={onChange}
      onIncrement={onIncrement}
      onDecrement={onDecrement}
      isIncrementDisabled={isIncrementDisabled}
      isDecrementDisabled={isDecrementDisabled}
      isDisabled={isDisabled}
      hint={
        minimumOrderQuantity > 1 &&
        `Minimum quantity: ${formatQuantityWithUnit({
          quantity: minimumOrderQuantity,
          unit: quantityUnit,
        })}`
      }
      {...rest}
    />
  </Flex>
)
